import { endOfDay, isAfter } from "date-fns";
import _ from "lodash";
import { displayId, utcDate } from "src/utility/utilityFunctions";

import { Image } from "@models/Image";
import { Item } from "@models/Item";
import { Variant } from "@models/Variant";
import { VariantAllocation } from "@models/VariantAllocation";

export function isPrintReadyDownloadable(
  item: Pick<Item, "orderableEndDate">
): boolean {
  if (!item.orderableEndDate) return true;
  return isAfter(endOfDay(utcDate(item.orderableEndDate)), new Date());
}

export function getItemPreviewImage(item: Pick<Item, "images">): Image | null {
  const sortedImages = _(item.images)
    .filter((i) => i.type === "large")
    .sortBy("position")
    .value();

  return sortedImages[0] ?? null;
}

export const allocationName = (alloc: VariantAllocation): string =>
  alloc.subStateName ?? alloc.territoryName ?? "";

export const variantId = (variant: Variant) =>
  displayId(variant.variantSku, variant.runNumber);
